import React, {useEffect, useState} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {Business, BusinessLocation, CurrentUser, UserCard, UserType} from "../../types/Types";
import "./../../App.css"
import "./LocationsPage.css"
import {db} from "../../firebase/FirebaseProvider";
import LocationRow from "../../components/location/LocationRow";
import {faLocationCrosshairs} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getDistanceFromLatLonInKm} from "../../utils/Utils";import {useNavigate} from "react-router";
import LoadingWheel from "../../components/loading/LoadingWheel";

interface Props {
  currentUser: CurrentUser | undefined,
  businessMap: Map<string, Business>,
  userCardsMap: Map<string, UserCard>,
}

interface Coordinates {
  lat: number,
  lng: number,
}

function LocationsPage(props: Props) {
  const navigate = useNavigate();

  const [locations, setLocations] = useState<Array<BusinessLocation>>([]);
  const [coordinates, setCoordinates] = useState<Coordinates | undefined>();

  const filteredLocations = () => {
    if(coordinates) {
      return locations.sort((a,b) => getDistance(a.location.latitude || 0, a.location.longitude || 0)! - getDistance(b.location.latitude || 0, b.location.longitude || 0)!)
    } else {
      return locations.sort((a,b) => +b.createdAt - +a.createdAt)
    }
  };

  useEffect(() => {(async () => {
    let locations = new Array<BusinessLocation>();
    const locationsCollection = query(
        collection(db, 'locations'),
        where("active", "==",true),
        orderBy("createdAt", "asc"),
        limit(200),
    );
    const locationsSnapshot = await getDocs(locationsCollection);
    locationsSnapshot.forEach((doc) => {
      locations.push(doc.data() as BusinessLocation);
    });
    setLocations(locations);
  })();
  }, []);

  const getDistance = (lat: number, lng: number): number | undefined => {
    if(coordinates) {
      return +getDistanceFromLatLonInKm(coordinates.lat, coordinates.lng, lat, lng).toFixed(1)
    }
    return undefined
  };

  const findNearestLocations = () => {
    navigator.geolocation.getCurrentPosition(
        async currentLocation => {
          setCoordinates({lat: currentLocation.coords.latitude, lng: currentLocation.coords.longitude} as Coordinates);
        },
        err => {
          alert(
              "Unable to get your location. Make sure you've enabled GPS! " + err.message
          );
        },
        {
          maximumAge: 1000,
          enableHighAccuracy: true
        }
    );
  };

  const doesUserOwnACard = (business: string) => {
    if (!business) {
      return undefined
    }
    return props.userCardsMap.get(business)
  };

  return (
      <>
        <div>
          <div className={""}>

            {(!props.currentUser || props.currentUser.userType === UserType.CUSTOMER) && <div className={"list-title mb-0-6"}>
              <div className={"d-inline-block font-1-2"}><b>Locations</b></div>
              <div className={"float-right font-md"} style={{marginTop: "5px"}}>
                <div className={"find-my-location-button ms-1 bg-blue"} onClick={() => findNearestLocations()}>
                  <FontAwesomeIcon icon={faLocationCrosshairs} />
                </div>
              </div>
            </div>}

            {(props.currentUser && props.currentUser.userType === UserType.LOCATION_MANAGER) && <div className={"basic-box"}>
              <div className={"d-inline-block"}><b>My Locations</b></div>
            </div>}

            <div>
              {filteredLocations().map((location, index) => (
                  <div className={`cursor-pointer ${index === locations.length-1 ? 'mb-0' : 'mb-2'}`} onClick={() => navigate(`/location/${location.id}`)}>
                    <LocationRow
                        location={location}
                        business={props.businessMap.get(location.business)}
                        distance={getDistance(location.location.latitude, location.location.longitude)}
                        displayCard={doesUserOwnACard(location.business) != undefined}
                    />
                  </div>
              ))}
              <div className={"centre-align"}>
                {(!locations || locations.length === 0) && <LoadingWheel />}
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default LocationsPage;
